import React from 'react';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import WaitlistStatusCheck from './components/WaitlistStatusCheck';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import bgImg from 'assets/img/generic/17.jpg';

const WaitlistStatus = () => {
  const { t } = useTranslation();
  return (
    <AuthSplitLayout bgProps={{ image: bgImg, position: '50% 76%', overlay: true }}>
      <h3>{t('WAITLIST.STATUS_TITLE')}</h3>
      <p className="text-muted mb-4">
        {t('WAITLIST.STATUS_SUBTITLE')}
      </p>
      <WaitlistStatusCheck />
      <p className="pt-3 mb-0 fs--1 text-600">
        {t('WAITLIST.WANT_TO_JOIN')}
        <br />
        <Button
          as={Link}
          variant="outline-primary"
          className="mt-2 px-4"
          to="/waitlist"
        >
          {t('WAITLIST.APPLY_NOW')}
        </Button>
      </p>
    </AuthSplitLayout>
  );
};

export default WaitlistStatus;
